import { PROMO_CODES_PATH } from 'modules/promo-codes/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'

function getNamePromoCodeUtil (promoCode) {
  return getValueReduxUtil(promoCode, 'name')
}

/**
 * Gets the `PromoCode` path using the given id.
 * @returns {String?}
 */
function getPathPromoCodeUtil (promoCode) {
  if (!promoCode) {
    return
  }
  return `${PROMO_CODES_PATH.DATA}.${(getNamePromoCodeUtil(promoCode) || '').toLowerCase()}`
}

/**
 * Gets the discount of the given `subTotal` and `promoCodes`.
 * @param  {number} subTotal
 * @param  {PromoCode[]} promoCodes
 * @returns {number}
 */
function getDiscountPromoCodeUtil (subTotal, promoCodes) {
  const promo = promoCodes.reduce((promoTotal, promoCode) => {
    promoTotal += promoCode.data.value
    return promoTotal
  }, 0)
  return subTotal * promo
}

export {
  getDiscountPromoCodeUtil,
  getPathPromoCodeUtil,
  getNamePromoCodeUtil
}
